import { render, staticRenderFns } from "./TenantAware.vue?vue&type=template&id=5514e9b0&"
import script from "./TenantAware.vue?vue&type=script&lang=js&"
export * from "./TenantAware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports